module.exports = __webpack_public_path__ + "static/36-12n-379o-03-7844a8d628e29082652971e4d2ed4bad.jpg";